import styled from 'styled-components';

const SELECTION_BAR_FLOATING_TOP = 142;
const SELECTION_BAR_HEIGHT = 60;

export const SelectionActionBarAnchor = styled.div`
  width: 100%;
  height: ${(props) => (props.$isFloating ? `${SELECTION_BAR_HEIGHT}px` : '0')};
  flex-shrink: 0;
`;

export const SelectionActionBarContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: none;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  border-radius: 8px;
  border: 0.5px solid #80afff;
  background: #ffffff;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  margin-top: ${(props) => (props.$isFloating ? '0' : '-56px')};
  margin-bottom: 12px;
  position: ${(props) => (props.$isFloating ? 'fixed' : 'relative')};
  top: ${(props) => (props.$isFloating ? `${SELECTION_BAR_FLOATING_TOP}px` : 'auto')};
  left: ${(props) => (props.$isFloating ? '50%' : 'auto')};
  transform: ${(props) => (props.$isFloating ? 'translateX(-50%)' : 'none')};
  box-shadow: 0 4px 16px rgba(9, 30, 66, 0.08);
  box-sizing: border-box;
  z-index: 999;

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    max-width: none;
    padding: ${(props) => (props.$isFloating ? '10px 12px' : '12px')};
  }

  @media (max-width: 480px) {
    width: 100%;
    max-width: none;
    padding: ${(props) => (props.$isFloating ? '8px 12px' : '12px')};
  }
`;

export const SelectionActionBarInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  width: 100%;
`;

export const SelectionInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SelectionActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`;

export const CloseSelectionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  background: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  color: #0a0a0a;
  margin-left: 8px;
  transition: all 0.15s ease;

  &:hover {
    background: #e9ebef;
    color: #030213;
  }
`;
